import "./LocalSeoConsultantPeterborough.module.css";
import Header from "@/reusable_sections/Header";
import Consultation from "./sections/Consultation";
import Sectors from "./sections/Sectors";
import Localseohero from "./sections/Localseohero";
import Servicesgrid from "./sections/Servicesgrid";
import ConsultantBenefits from "./sections/ConsultantBenefits";
import PeterboroughMarketAnalysis from "./sections/PeterboroughMarketAnalysis";
import Methodology from "./sections/Methodology";
import PeterboroughFaq from "./sections/PeterboroughFaq";
import PeterboroughMarket from "./sections/PeterboroughMarket";
import CaseStudyResults from "./sections/CaseStudyResults";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantPeterboroughPage() {
  return <div>
      <Header />
      <Consultation />
      <Sectors />
      <Localseohero />
      <Servicesgrid />
      <ConsultantBenefits />
      <PeterboroughMarketAnalysis />
      <Methodology />
      <PeterboroughFaq />
      <PeterboroughMarket />
      <CaseStudyResults />
      <Footer />
    </div>;
}